import request from '@/utils/request'

export function getOAuth() {
  return request({
    url: '/oauth/server',
    method: 'get'
  })
}

export function getOAuthCertification(data) {
  return request({
    url: `/oauth/authorize?code=${data}`,
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/oauths.js